import React from "react";
import { customStyles } from "../constants/customStyles";
import { getTimeString } from "../utils/general";
import { classnames } from "../utils/general";
import ClockSvg from '../assets/clock.svg';
import Select from "react-select";
import CodeEditorWindow from "./CodeEditorWindow";
import { BASE_BUTTON_CLASS } from "../constants/common";

const CodeWindow = ({ 
  onLanguageChange,
  allLanguages,
  language,
  timer,
  handleCompile,
  setOpenPopup,
  setCode,
  theme,
  code,
  isCompiling,
  isSubmitting
}) => {
  const timerValue = getTimeString(timer);

  return (
    <div className="bg-black-fade p-3 pb-4 w-full">
      <div 
        className="flex flex-row min-w-full h-[72px] py-4
          items-center justify-between bg-brilliance-black rounded-t-[20px]"
      >
        <div className="px-4 py-2 flex flex-row">
          <Select
            placeholder="Select Language"
            onChange={onLanguageChange}
            options={allLanguages}
            styles={customStyles}
            defaultValue={allLanguages[0]}
            value={language}
          />
        </div>
        <div className="flex items-center">
          <span className="w-[24px] mr-3"><img src={ClockSvg} /></span>
          <span className="text-base font-medium text-white">
            {timerValue}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <button
            onClick={handleCompile}
            disabled={!code || isCompiling || isSubmitting}
            className={classnames(
              BASE_BUTTON_CLASS
            )}
          >
            {isCompiling ? "Compiling..." : "Compile"}
          </button>
          <button
            onClick={() => setOpenPopup(true)}
            disabled={isCompiling || isSubmitting}
            className={classnames(
              BASE_BUTTON_CLASS
            )}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
      {/* Extract in separate component */}
      <div className="w-[100%] h-[440px] justify-start items-end">
        <CodeEditorWindow
          code={code}
          onChange={setCode}
          language={language?.value}
          theme={theme.value}
        />
      </div>
    </div>
  );
};

export default CodeWindow;